// ABOUTME: The legacy nav's home for the extended view preference, which the spark nav offers on the
// ABOUTME: schedule page itself. Goes when the legacy nav does, and its route with it.

import { Box, Flex, Heading2, LoadingAnimation, Text, Toggle } from "@nulogy/components";
import PageWithBreadcrumbs from "components/pages/PageWithBreadcrumbs";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import useExtendedView, { EXTENDED_VIEW_DESCRIPTION, EXTENDED_VIEW_LABEL } from "hooks/apollo/user/useExtendedView";
import React from "react";
import styled from "styled-components";

const Description = styled(Text)`
  margin-left: 56px;
`;

export default function UserPreferences() {
  const { user } = useApplicationContext();
  const { extendedView, loading, updateExtendedView } = useExtendedView();

  if (!user) return <LoadingAnimation />;

  return (
    <PageWithBreadcrumbs title="Preferences">
      <Flex justifyContent="center" width="100%">
        <Box boxShadow="small" p="x2" width="720px">
          <Heading2>Schedule</Heading2>
          <Toggle
            aria-label={EXTENDED_VIEW_LABEL}
            disabled={loading}
            offText={EXTENDED_VIEW_LABEL}
            onChange={updateExtendedView}
            onText={EXTENDED_VIEW_LABEL}
            toggled={extendedView}
          />
          <Description disabled={loading} fontSize="small">
            {EXTENDED_VIEW_DESCRIPTION}
          </Description>
        </Box>
      </Flex>
    </PageWithBreadcrumbs>
  );
}
